<template>
  <div>
    <v-container fluid v-if="!selectedCommunityShortName">
      <v-row justify="end" dense>
        <v-col cols="12" sm="4">
          <SearchMoc></SearchMoc>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-if="!selectedCommunityShortName">
      <label>Select your community</label>
      <v-data-table
        :headers="communityHeaders"
        :items="activeCommunities"
        style="border: solid 1px"
        :loading="gettingCommunities"
        :no-data-text="gettingCommunities ? 'Loading...' : 'No data available'"
        disable-pagination
        hide-default-footer
        :items-per-page="-1"
        :sort-by="sortBy"
      >
        <template v-slot:item="props">
          <tr>
            <td>
              <a @click="selectCommunity(props.item)" class="blue-link">{{ props.item.communityName }}</a>
            </td>
            <td>{{ props.item.communityAbbreviation }}</td>
          </tr>
        </template>
      </v-data-table>
      <br /><br />
      <label>Inactive Communities</label>
      <v-data-table
        :headers="communityHeaders"
        :items="inactiveCommunities"
        style="border: solid 1px"
        :loading="gettingCommunities"
        :no-data-text="gettingCommunities ? 'Loading...' : 'No data available'"
        disable-pagination
        hide-default-footer
        :items-per-page="-1"
        :sort-by="sortBy"
      >
        <template v-slot:item="props">
          <tr>
            <td>
              <a @click="selectCommunity(props.item)" class="blue-link">{{ props.item.communityName }}</a>
            </td>
            <td>{{ props.item.communityAbbreviation }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-container>

    <v-container v-if="selectedCommunityShortName && community.communityAbbreviation">
      <v-row dense>
        <v-col cols="6">
          <p class="screenHeading mt-4">{{ community.communityName }} ({{ community.communityAbbreviation }})</p>
        </v-col>
      </v-row>
    </v-container>

    <v-row v-if="news.length > 0">
      <v-col cols="12" sm="12" md="12">
        <vueper-slides
          :autoplay="news.length > 1"
          :pause-on-hover="pauseOnHover"
          fixed-height="50px"
          :bulletsOutside="news.length > 1 ? true : false"
          :touchable="false"
        >
          <template #arrow-left>
            <v-icon dark> mdi-chevron-left </v-icon>
          </template>

          <template #arrow-right>
            <v-icon dark> mdi-chevron-right </v-icon>
          </template>
          <vueper-slide v-for="(item, index) in news" :key="index" :content="item.message" :style="item.style" />
        </vueper-slides>
      </v-col>
    </v-row>

    <v-container v-if="selectedCommunityShortName && community.communityAbbreviation">
      <v-row>
        <v-col cols="12" sm="12" md="6">
          <!--donna only wants this visible if on mobile-->
          <v-col style="border: solid 1px" class="pa-2">
            <div v-show="!(community.newDisabled || community.inactive)">
              <a class="blue-link new-moc-link" :href="`/${selectedCommunityShortName}/moc`">Enter a new MOC</a>
            </div>
            <span v-if="categories.length" class="screenHeading">Show me MOCs</span>
            <ul style="padding-left: 20px;">
              <li v-for="item in categories" :key="item.name">
                <a
                  class="blue-link"
                  @click="selectedCategory = item.name"
                  :style="selectedCategory === item.name ? 'text-decoration:none; color: black;' : 'text-decoration: underline'"
                  >{{ item.display }}<span v-if="!item.loading"> ({{ item.count }})</span></a
                >
                <v-progress-circular
                  width="2"
                  size="20"
                  color="gray"
                  class="ml-1"
                  indeterminate
                  v-if="item.loading"
                ></v-progress-circular>
              </li>
            </ul>
          </v-col>
        </v-col>
        <v-col cols="12" sm="12" md="6">
          <v-col style="border: solid 1px">
            <!-- <v-row class="pa-2"> -->
            <SearchMoc :communityAbbreviation="selectedCommunityShortName"></SearchMoc>
            <!-- </v-row> -->
          </v-col>
          <v-col
            style="border: solid 1px"
            class="mt-3 pt-3"
            v-if="!gettingCommunities && community.helpfulLinks && community.helpfulLinks.length > 0"
          >
            <v-col>
              <span class="screenHeading">{{ $t('Helpful_Links') }}</span>
              <ul style="padding-left: 20px;">
                <li v-for="item in community.helpfulLinks" :key="item.id">
                  <a class="blue-link" v-bind:href="'//' + item.url" target="_blank">{{ item.display }}</a>
                </li>
              </ul>
            </v-col>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
    <div v-if="selectedCategory">
      <MOCList :community="community" :selectedCategory="selectedCategory"></MOCList>
    </div>
    <Toaster ref="toaster"></Toaster>
  </div>
</template>
<script>
import MOCAdminService from '@/services/admin.service'
import ApprovalService from '@/services/approval.service'
import TaskService from '@/services/task.service'
import MOCService from '@/services/moc.service'
import MOCList from '@/components/Mocs'
import { mapState } from 'vuex'
import SearchMoc from '@/components/SearchMoc'
import i18next from 'i18next'
import Toaster from '@/components/Toaster'
import { EventBus } from '@/common/event-bus'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import NewsService from '@/services/news.service'

export default {
  name: 'CommunityDashboard',
  components: {
    MOCList,
    SearchMoc,
    Toaster,
    VueperSlides,
    VueperSlide
  },
  data() {
    const categorizedMocs = [
      { name: 'initiator', display: this.$t('Category_Init'), mocs: [], displayKey: 'Category_Init', count: 0, loading: true },
      {
        name: 'coInitiator',
        display: this.$t('Category_CoInit'),
        mocs: [],
        displayKey: 'Category_CoInit',
        count: 0,
        loading: true
      },
      { name: 'stop', display: this.$t('Category_Stop'), mocs: [], displayKey: 'Category_Stop', count: 0, loading: true },
      {
        name: 'waitingForApproval',
        display: this.$t('Category_WaitingForApproval'),
        mocs: [],
        displayKey: 'Category_WaitingForApproval',
        count: 0,
        loading: true
      },
      {
        name: 'fyi',
        display: this.$t('Category_FYI'),
        mocs: [],
        displayKey: 'Category_FYI',
        count: 0,
        loading: true
      },
      {
        name: 'pendingApproval',
        display: this.$t('Category_PendingApproval'),
        mocs: [],
        displayKey: 'Category_PendingApproval',
        count: 0,
        loading: true
      },
      {
        name: 'ownerDeferred',
        display: this.$t('Category_OwnerDeferred'),
        mocs: [],
        displayKey: 'Category_OwnerDeferred',
        count: 0,
        loading: true
      },
      {
        name: 'facilitator',
        display: this.$t('Category_Facilitator'),
        mocs: [],
        displayKey: 'Category_Facilitator',
        count: 0,
        loading: true
      },
      {
        name: 'tasksPending',
        display: this.$t('Category_PendingTasks'),
        mocs: [],
        displayKey: 'Category_PendingTasks',
        count: 0,
        loading: true
      },
      {
        name: 'accountable',
        display: this.$t('Category_Accountable'),
        mocs: [],
        displayKey: 'Category_Accountable',
        count: 0,
        loading: true
      },
      {
        name: 'confirmChange',
        display: this.$t('Category_ConfirmChange'),
        mocs: [],
        displayKey: 'Category_ConfirmChange',
        count: 0,
        loading: true
      },
      {
        name: 'coordinatorOfUnauthorizedExpired',
        display: this.$t('Category_Coordinator_Unauthorized_Expired'),
        mocs: [],
        displayKey: 'Category_Coordinator_Unauthorized_Expired',
        count: 0,
        loading: true
      },      
      {
        name: 'ownerOfUnauthorizedExpired',
        display: this.$t('Category_Owner_Unauthorized_Expired'),
        mocs: [],
        displayKey: 'Category_Owner_Unauthorized_Expired',
        count: 0,
        loading: true
      },
      {
        name: 'ownerOfInProcessTemporary',
        display: this.$t('Category_Owner_Temporary_InProcess'),
        mocs: [],
        displayKey: 'Category_Owner_Temporary_InProcess',
        count: 0,
        loading: true
      },
      {
        name: 'ownerOfAllInProcess',
        display: this.$t('Category_Owner_All_InProcess'),
        mocs: [],
        displayKey: 'Category_Owner_All_InProcess',
        count: 0,
        loading: true
      },
      {
        name: 'allInProcessFacilitatorSubmitted',
        display: this.$t('Category_InProcessFacilitatorSubmitted'),
        mocs: [],
        displayKey: 'Category_InProcessFacilitatorSubmitted',
        count: 0,
        loading: true
      },
      {
        name: 'allInProcessFacilitatorSentBack',
        display: this.$t('Category_InProcessFacilitatorSentBack'),
        mocs: [],
        displayKey: 'Category_InProcessFacilitatorSentBack',
        count: 0,
        loading: true
      }
    ]
    return {
      communityHeaders: [
        {
          title: 'Name',
          key: 'communityName'
        },
        {
          title: 'Short Name',
          key: 'communityAbbreviation'
        }
      ],
      sortBy: [{ key: 'communityName', order: 'asc' }],
      communities: [],
      activeCommunities: [],
      inactiveCommunities: [],
      gettingCommunities: false,
      gettingMocs: false,
      selectedCommunityShortName: null,
      community: {
        helpfulLinks: []
      },
      queries: [],
      selectedQuery: null,
      mocs: [],
      filteredMocs: [],
      selectedCategory: null,
      categorizedMocs,
      news: [],
      pauseOnHover: true
    }
  },
  computed: {
    ...mapState('currentUser', ['user']),
    categories() {
      return this.categorizedMocs.filter((c) => (c.loading ? true : c.count > 0))
    }
  },
  methods: {
    selectCommunity(comm) {
      this.$store.dispatch('currentCommunity/setCommunity', {
        communityAbbreviation: comm.communityAbbreviation,
        communityName: comm.communityName
      })
      EventBus.emit('updateNavRoles')
      this.$router.push(`${comm.communityAbbreviation}/CommunityDashboard`)
    },
    selectCommunityEvent() {
      // 'navigate' to this page but with a community param
      this.$router.push(`${this.selectedCommunityShortName}/CommunityDashboard`)
    },
    getCommunities() {
      if (!this.gettingCommunities) {
        this.gettingCommunities = true
        if (this.selectedCommunityShortName) {
          MOCAdminService.getHelpfulLinks(this.selectedCommunityShortName).then(
            (links) => (this.community.helpfulLinks = links || [])
          )
          MOCAdminService.getCommunitySummary(this.selectedCommunityShortName)
            .then((community) => {
              community.helpfulLinks = this.community.helpfulLinks
              this.community = community
              this.setupDisplayNames(community.communityAbbreviation)
            })
            .catch((e) => {
              // TODO: determine if we need to do anything here
              console.log(e)
            })
            .finally(() => {
              this.gettingCommunities = false
            })
        } else {
          MOCAdminService.getCommunity()
            .then((succ) => {
              this.activeCommunities = succ.filter((a) => {
                return !a.hasOwnProperty('inactive') || a.inactive === false
              })
              this.inactiveCommunities = succ.filter((i) => {
                return i.inactive === true
              })
            })
            .catch((e) => {
              // TODO: determine if we need to do anything here
              console.log(e)
            })
            .finally(() => {
              this.gettingCommunities = false
            })
        }
      }
    },
    async getMocs() {
      if (!this.gettingMocs) {
        this.gettingMocs = true

        let chunks = []

        for (let i = 0; i < this.categorizedMocs.length; i = i + 3) {
          chunks.push(this.categorizedMocs.slice(i, i + 3))
        }
        for (let chunk of chunks) {
          let counts = []
          for (let category of chunk) {
            if (category.name === 'waitingForApproval') {
              counts.push(this.getPendingApprovalsCount(category))
              continue
            }

            if (category.name === 'tasksPending') {
              counts.push(this.getPendingTasksCategoryCount(category))
              continue
            }

            counts.push(
              MOCService.getMOCDashboardCount(this.selectedCommunityShortName, category.name)
                .then((count) => (category.count = count))
                .finally(() => {
                  category.loading = false
                })
            )
          }

          Promise.all(counts)
        }
      }
    },
    getNewsForThisCommunity(communityAbbreviation) {
      if (communityAbbreviation != null) {
        return new Promise((resolve, reject) => {
          NewsService.getNews(communityAbbreviation)
            .then((data) => {
              this.news = data
              resolve()
            })
            .catch((e) => {
              this.$refs.loadingDialog.error({ metadata: 'mount', error: e, message: 'Could not load News' })
              reject(e)
            })
            .finally(() => {
              for (let i = 0; i < this.news.length; i++) {
                this.setNewsItemColor(i)
              }
            })
        })
      }
    },
    getPendingApprovalsCount(category) {
      return ApprovalService.getPendingApprovalsMOCDashboardCount(this.selectedCommunityShortName)
        .then((data) => {
          this.categorizedMocs.find((x) => x.name === 'waitingForApproval').count = data
        })
        .catch(() => {})
        .finally(() => {
          category.loading = false
        })
    },
    getPendingTasksCategoryCount(category) {
      return TaskService.getTasksPendingMOCDashboardCount(this.selectedCommunityShortName)
        .then((data) => {
          this.categorizedMocs.find((x) => x.name === 'tasksPending').count = data
        })
        .catch((err) => {
          // TODO: (tony) send to app insights
          // console.log(err)
        })
        .finally(() => {
          category.loading = false
        })
    },
    setNewsItemColor(index) {
      if (this.news[index]) {
        let bg = '#388E3C'
        switch (this.news[index].type) {
          case 'Important': {
            bg = '#c70000'
            break
          }
          case 'Warning': {
            bg = '#FFBA01'
            break
          }
        }

        this.news[index].style = this.news[index].style || {}
        this.news[index].style.background = this.news[index].style.background || {}
        this.news[index].style.background = bg

        this.$forceUpdate()
      }
    },
    setupDisplayNames(communityAbbreviation) {
      let displayNames = {}

      // check for overrides...
      let overrides = this.$store.state.overrides.communityOverrides
      if (overrides.find((o) => o.communityAbbreviation === communityAbbreviation)) {
        // there's an override, just load defaults.
        displayNames = JSON.parse(JSON.stringify(i18next.getResourceBundle('en')))
        i18next.addResourceBundle('en', communityAbbreviation, displayNames, false, true)
        i18next.setDefaultNamespace(communityAbbreviation)
        this.translate()
        this.$refs.toaster.pop('success', 'Overriding Display Names')
      } else {
        MOCAdminService.getDisplayNames(communityAbbreviation)
          .then((data) => {
            displayNames = data
          })
          .catch((e) => {
            console.log(e)
          })
          .finally(() => {
            i18next.addResourceBundle('en', communityAbbreviation, displayNames, false, true)
            i18next.setDefaultNamespace(communityAbbreviation)
            this.translate()
          })
      }
    },
    translate() {
      // need to do this to get the proper names coming in...
      // timing issues between initial setting and translations loading
      // loop through and reset the display values
      this.categorizedMocs.forEach((category) => {
        category.display = this.$t(category.displayKey)
      })
    }
  },
  beforeMount() {
    this.selectedCommunityShortName = this.$route.params.shortName
    this.getCommunities(this.selectedCommunityShortName)
    if (!this.selectedCommunityShortName) {
      // this is only to populate the dropdown
      // so no need if they came via link or something
      // can easily change later if they wanna change community from this page
      this.getCommunities()
      // reset the translations/displayNames to default when going to view all communities
    } else {
      this.getMocs().finally(() => (this.gettingMocs = false))
    }
    for (var i = 0; i < 25; i++) {
      this.queries.push({
        id: i,
        display: 'Query link ' + i
      })
    }

    this.getNewsForThisCommunity(this.selectedCommunityShortName)
  }
}
</script>

<style scoped>
.nopad.v-text-field.v-text-field--enclosed .v-input__slot {
  padding: 0;
}
.blue-link {
  color: #0000ee;
  text-decoration: underline;
}

.new-moc-link {
  font-size: 18px;
  font-weight: bold;
}

.centered-col {
  align-items: center;
  display: flex;
}

.search-btn {
  top: -5px;
  position: relative;
}
</style>
